import { Box } from "@mui/material"
import { StyledTableCell } from "components/tables/StyledTable"
import ArrowDropDownRoundedIcon from "@mui/icons-material/ArrowDropDownRounded"
import ArrowDropUpRoundedIcon from "@mui/icons-material/ArrowDropUpRounded"
import { useCallback } from "react"
import { SortOrder, SORTORDER } from "types/sort"
import { InvoiceCellComponent, InvoicesTableColumnsType } from "layouts/invoices/utils/types"
import { StatusError as Error, StatusWaiting as Waiting, StatusValidation as Validation } from "components/status";
import { OreveButton } from "components/button/OreveButton.tsx"
import DownloadIcon from '@mui/icons-material/Download';



export const DateInvoiceCell: InvoiceCellComponent = ({ invoice }) => {
    return <>{invoice.issueDate}</>
    
}

export const NumberInvoiceCell: InvoiceCellComponent = ({ invoice }) => {
    return <>{invoice.number}</>
}

export const PriceNoTaxesInvoiceCell: InvoiceCellComponent = ({ invoice }) => {
    return <>{invoice.TotalWithoutTax}€</>
}

export const PriceWithTaxesInvoiceCell: InvoiceCellComponent = ({ invoice }) => {
    return <>{invoice.TotalWithTax}€</>
}

export const StatusInvoiceCell: InvoiceCellComponent = ({ invoice }) => {
    switch (invoice.status) {
        case "UNPAID":
            return <Error text={"Impayée"} />
        case "IN_PROGRESS":
            return <Waiting text={"En attente de paiement"} />
        case "PAID":
            return <Validation text={"Payée"} />
        default:
            return null
    }
}

export const DownloadInvoiceCell: InvoiceCellComponent = () => {
    return (
        <OreveButton icon={DownloadIcon} value={"Télécharger"} variant={"text"} />
    )
}

export const InvoiceHeaderCell = ({
    keyInvoice,
    title,
    width,
    unsortable = false,
    orderBy,
    sortOrder,
    setOrderBy,
    setSortOrder
}: {
    keyInvoice: keyof InvoicesTableColumnsType
    title: string
    width: string
    unsortable: boolean
    sortOrder: SortOrder
    orderBy: keyof InvoicesTableColumnsType
    setSortOrder: React.Dispatch<React.SetStateAction<SortOrder>>
    setOrderBy: React.Dispatch<React.SetStateAction<keyof InvoicesTableColumnsType>>

}) => {

    const onSort = useCallback(
        (orderBy: keyof InvoicesTableColumnsType) => {
            if (unsortable) return
            setOrderBy(orderBy)
            setSortOrder((sortOrder: SortOrder) =>
                sortOrder === SORTORDER.ASC ? SORTORDER.DESC : SORTORDER.ASC
            )
        },
        [setOrderBy, setSortOrder, unsortable]
    )

    return (
        <StyledTableCell
            onClick={() => onSort(keyInvoice)}
            sx={{
                width: width,
               ...(!unsortable ? {cursor: "pointer"} : {}),
            }}
        >
            <Box
                sx={{
                    position: "relative",
                    display: "flex",
                    flexDirection: "row",
                    alignItems: "center",
                    width:
                        orderBy !== keyInvoice ? "calc(100% + 0.5rem)" : "100%",
                }}
            >
                {title}
                {orderBy === keyInvoice && sortOrder === SORTORDER.ASC && (
                    <ArrowDropUpRoundedIcon
                        sx={{
                            p: 0,
                            m: 0,
                            ml: '16px',
                            height: "0.5rem",
                            width: "0.5rem",
                            transform: "scale(3.5)",
                            color: "grey.600",
                        }}
                        data-testid="arrow-up-sort-table-invoice"
                    />
                )}
                {orderBy === keyInvoice && sortOrder === SORTORDER.DESC && (
                    <ArrowDropDownRoundedIcon
                        sx={{
                            p: 0,
                            m: 0,
                            ml: '16px',
                            height: "0.5rem",
                            width: "0.5rem",
                            transform: "scale(3.5)",
                            color: "grey.600",
                        }}
                        data-testid="arrow-down-sort-table-invoice"
                    />
                )}
            </Box>
        </StyledTableCell>
    )
}
